export const environment = {
    production: true,
    // base_url: 'https://orca-app-esbbl.ondigitalocean.app/'
    // base_url: 'http://10.106.16.4/'
    base_url: 'https://gemini-api.unireal.io/',
    recaptchaEnterpriseSiteKey: '6LeDSs0sAAAAAJxpD7cLOU5FaNbUD_PFyaXCfZqC',
    // recaptchaEnterpriseSiteKey: '',
    recaptchaEnterpriseStartAction: 'qr_access_start_verification',
    recaptchaEnterpriseVerifyAction: 'qr_access_verify_code'
  };
